export const CUSTOM_HIDDEN_ALERT_URL = [
  'auth/pin/validate',
  'auth/v2/pin/change/new',
  'auth/v2/pin/change/confirm',
  'auth/v2/pin/reset/new',
  'auth/v2/pin/reset/confirm',
];
